export function schema_nettoyage(prevColumnNames) {
	// todo faire en sorte qu'on ne puisse uniquement choisir min ou MAJ pas les deux (anyOf ?)
	// todo ou alors un enum ?

	return {
		title: "Paramètres",
		type: "object",
		properties: {
			columns: {
				type: "array",
				title: "Colonnes",
				format: "table",
				items: {
					title: "Colonne",
					type: "string",
					options: {
						inputAttributes: {
							class: "form-control dropdown-colonne",
						},
					},
				},
			},
			// "casing": {
			//     "type": "string",
			//     "title": "Mettre en majuscule ou minuscule (laisser vide pour ne rien faire)",
			//     "enum": ["", "MAJUSCULE", "minuscule"]
			// },
			uppercase: {
				type: "boolean",
				title: "Mettre en MAJUSCULE",
				format: "checkbox",
				// ! les templates ne marchent pas pour les checkbox
				// "template": "{{ letterCasing === 'MAJUSCULE' }}",
				// "watch": {
				//     "letterCasing": "casing"
				// }
			},
			lowercase: {
				type: "boolean",
				title: "Mettre en minuscule",
				format: "checkbox",
				// ! les templates ne marchent pas pour les checkbox
				// "template": "{{ letterCasing === '' }}",
				// "watch": {
				//     "letterCasing": "casing"
				// }
			},
			capitalize: {
				type: "boolean",
				title: "Nom Propre",
				format: "checkbox",
			},
			sentence: {
				type: "boolean",
				title: "Mettre en majuscule. La première lettre de chaque phrase",
				format: "checkbox",
			},
			replace: {
				type: "array",
				title: "Remplacer",
				format: "table",
				items: {
					type: "object",
					title: "Remplacer",
					properties: {
						from: {
							type: "string",
							title: "Recherche",
						},
						to: {
							type: "string",
							title: "Valeur de remplacement",
						},
					},
				},
			},
		},
	};
}
